// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../imageLarge.fragment.generated';
import { LinkFragmentDoc } from '../../index.generated';
export const ArticlePreviewFragmentDoc = gql`
    fragment articlePreview on ArticlePreview {
  title
  subtitle
  image {
    ...imageLarge
  }
  link {
    ...link
  }
}
    ${ImageLargeFragmentDoc}
${LinkFragmentDoc}`;